<template>
  <div id="keysComponent">
    <div class="top">
      <p v-wave class="tabName" :class="item.status ? 'tabNameActive' : ''" v-for="item in tabList" :key="item.value" @click="tabChange(item)">
        {{$t(item.name)}}
      </p>
    </div>
    <div class="keys">
      <div class="keysIn">
        <div v-show="tabList[0].status" class="btns_box animate__animated animate__fadeIn">
          <div class="btns">
            <div class="letter"
                  v-for="(letter, index) in key_name_replace[0]"
                 :key="letter"
                 @click="keyChange(letter)">
              <el-tooltip class="item" :open-delay="500" effect="dark" placement="top-start">
                <div slot="content">
                  <div>
                    <p>{{ KeyStrings[letter] }}</p>
                  </div>
                </div>
                <div class="button_out" :class="[[4,8].includes(index) ? 'interval1' : '',index === 0 ? 'interval6' : '',index === 62 ? 'interval7' : '',index === 75 ? 'interval5' : '',[12,29,46,62,83].includes(index) ? 'interval4' : '',index === 29 ? 'keyBig1': '',index === 33 || index === 46 ? 'keyBig2': '',[50].includes(index) ? 'keyBig3' : '',[62,63].includes(index) ? 'keyBig4' : '',index === 74 ? 'keyBig7' : '',[76,77,78,80,81,82,83].includes(index) ? 'keyBig5' : '',index === 79 ? 'keyBig6' : '']">
                  <button v-wave class="alphabet-button">
                    {{ KeyStrings[letter] }}
                  </button>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="btns btns_other">
            <div class="letter"
                 v-for="(letter) in key_name_pad"
                 :key="letter"
                 @click="keyChange(letter)">
              <el-tooltip class="item" :open-delay="500" effect="dark" placement="top-start">
                <div slot="content">
                  <div>
                    <p>{{ KeyStrings[letter] }}</p>
                  </div>
                </div>
                <div class="button_out" :class="letter === 98 ? 'keyBig1' : ''">
                  <button v-wave class="alphabet-button">
                    {{ KeyStrings[letter] }}
                  </button>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="btns btns_pad">
            <div class="letter"
                 v-for="(letter) in key_name_pad1"
                 :key="letter"
                 @click="keyChange(letter)">
              <el-tooltip class="item" :open-delay="500" effect="dark" placement="top-start">
                <div slot="content">
                  <div>
                    <p>{{ KeyStrings[letter] }}</p>
                  </div>
                </div>
                <div class="button_out" :class="letter === 87 || letter === 88 ? 'keyBig8' : ''">
                  <button v-wave class="alphabet-button">
                    {{ KeyStrings[letter] }}
                  </button>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div v-show="tabList[1].status" class="btns_box animate__animated animate__fadeIn">
          <div class="btns btns_feature">
            <div class="letter"
                 v-for="(letter) in expChar4"
                 :key="letter.value"
                 @click="keyChange(KeyCodes[letter.value])">
              <el-tooltip class="item" :open-delay="500" effect="dark" placement="top-start">
                <div slot="content">
                  <div>
                    <p>{{ $t(letter.title) }}</p>
                  </div>
                </div>
                <div class="button_out button_out_other">
                  <button v-wave class="alphabet-button">
                    {{ letter.name }}
                  </button>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="btns btns_feature">
            <div class="letter"
                 v-for="(letter) in expChar5"
                 :key="letter.value"
                 @click="keyChange(KeyCodes[letter.value])">
              <el-tooltip class="item" :open-delay="500" effect="dark" placement="top-start">
                <div slot="content">
                  <div>
                    <p>{{ $t(letter.title) }}</p>
                  </div>
                </div>
                <div class="button_out button_out_other">
                  <button v-wave class="alphabet-button">
                    {{ letter.name }}
                  </button>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="btns btns_feature">
            <div class="letter"
                 v-for="(letter) in expChar6"
                 :key="letter.value"
                 @click="keyChange(KeyCodes[letter.value])">
              <el-tooltip class="item" :open-delay="500" effect="dark" placement="top-start">
                <div slot="content">
                  <div>
                    <p>{{ $t(letter.title) }}</p>
                  </div>
                </div>
                <div class="button_out button_out_other">
                  <button v-wave class="alphabet-button">
                    {{ letter.name }}
                  </button>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="btns btns_feature">
            <div class="letter"
                 v-for="(letter) in expChar7"
                 :key="letter.value"
                 @click="keyChange(KeyCodes[letter.value])">
              <el-tooltip class="item" :open-delay="500" effect="dark" placement="top-start">
                <div slot="content">
                  <div>
                    <p>{{ $t(letter.title) }}</p>
                  </div>
                </div>
                <div class="button_out button_out_other">
                  <button v-wave class="alphabet-button">
                    {{ letter.name }}
                  </button>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="btns btns_feature">
            <div class="letter"
                 v-for="(letter) in expChar8"
                 :key="letter.value"
                 @click="keyChange(KeyCodes[letter.value])">
              <el-tooltip class="item" :open-delay="500" effect="dark" placement="top-start">
                <div slot="content">
                  <div>
                    <p>{{ letter.title }}</p>
                  </div>
                </div>
                <div class="button_out button_out_other">
                  <button v-wave class="alphabet-button">
                    {{ letter.name }}
                  </button>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import EventBus from '@/store/eventBus'
import {key_name_replace, KeyStrings, KeyCodes} from '@/store/state'
import EventBus from "@/store/eventBus";
export default {
  name: "keysComponent",
  data() {
    return {
      rearCoverSwitch: false,
      isConnected: false,
      key_name_replace: key_name_replace,
      key_name_pad: [83,84,85,95,96,97,92,93,94,89,90,91,98,99],
      key_name_pad1: [86,87,88],
      KeyStrings: KeyStrings,
      KeyCodes: KeyCodes,
      tabList:[
        {
          name: '基础',
          value: '0',
          status: true
        },
        {
          name: '功能',
          value: '1',
          status: false
        }
      ],
      expChar4: [
        {
          name: 'VolumeUp',
          value: 'VOLUME_UP',
          title: '音量加'
        },
        {
          name: 'VolumeDown',
          value: 'VOLUME_DOWN',
          title: '音量减'
        },
        {
          name: 'Mute',
          value: 'MUTE',
          title: '静音'
        },
        {
          name: 'PlayPause',
          value: 'PLAY_PAUSE',
          title: '播放/暂停'
        },
        {
          name: 'Stop',
          value: 'STOP',
          title: '停止'
        },
        {
          name: 'PrevTrack',
          value: 'PREV_TRACK',
          title: '上一曲'
        },
        {
          name: 'NextTrack',
          value: 'NEXT_TRACK',
          title: '下一曲'
        },
        {
          name: 'Calculator',
          value: 'CALCULATOR',
          title: '计算器'
        },
        {
          name: 'Email',
          value: 'EMAIL',
          title: '邮件'
        },
        {
          name: 'Explorer',
          value: 'EXPLORER',
          title: '资源管理器'
        }
      ],
      expChar5: [
        {
          name: 'BootLoader',
          value: 'BOOTLOADER',
          title: '重启键盘到BOOT模式'
        },
        {
          name: 'Reboot',
          value: 'REBOOT',
          title: '重启键盘'
        },
        {
          name: 'DisableEx',
          value: 'DISABLE_EX',
          title: '暂时禁用RT'
        },
        {
          name: 'Enable_Ex',
          value: 'ENABLE_EX',
          title: '暂时启用RT'
        },
        {
          name: 'InitSet',
          value: 'INITSET',
          title: '重置配置'
        },
        {
          name: '~ESC',
          value: '~ESC',
          title: 'ESC，和shift一起按下时~'
        },
        {
          name: 'Config1',
          value: 'Config1',
          title: '切换配置1(一秒冷却)'
        },
        {
          name: 'Config2',
          value: 'Config2',
          title: '切换配置2(一秒冷却)'
        },
        {
          name: 'Config3',
          value: 'Config3',
          title: '切换配置3(一秒冷却)'
        },
        {
          name: 'Config4',
          value: 'Config4',
          title: '切换配置4(一秒冷却)'
        },
        {
          name: 'WinLock',
          value: 'WinLock',
          title: 'Win键锁开/关'
        },
        {
          name: '💡+',
          value: '💡+',
          title: '灯光亮度加'
        },
        {
          name: '💡-',
          value: '💡-',
          title: '灯光亮度减'
        },
        {
          name: '💡Switch',
          value: '💡Switch',
          title: '灯光开/关'
        },
        {
          name: 'Next💡',
          value: 'Next💡',
          title: '下一种灯效'
        },
        {
          name: 'Prev💡',
          value: 'Prev💡',
          title: '上一种灯效'
        }
      ],
      expChar6: [
        {
          name: 'Search',
          value: 'SEARCH',
          title: '浏览器搜索'
        },
        {
          name: 'HOME',
          value: 'HOME',
          title: '打开浏览器'
        },
        {
          name: 'Back',
          value: 'BACK',
          title: '浏览器回退'
        },
        {
          name: 'AC_Stop',
          value: 'AC_STOP',
          title: '浏览器停止加载'
        },
        {
          name: 'Forward',
          value: 'FORWARD',
          title: '浏览器前进'
        },
        {
          name: 'Refresh',
          value: 'REFRESH',
          title: '浏览器刷新'
        },
        {
          name: 'Bookmarks',
          value: 'BOOKMARKS',
          title: '浏览器书签'
        }
      ],
      expChar7: [
        {
          name: 'Bright_Up',
          value: 'BRIGHT_UP',
          title: '屏幕亮度加'
        },
        {
          name: 'Bright_Down',
          value: 'BRIGHT_DOWN',
          title: '屏幕亮度减'
        },
        {
          name: 'MAC_LAU',
          value: 'LAUNCHPAD',
          title: 'mac启动台'
        },
        {
          name: 'MAC_MIS',
          value: 'MISSION_CONTROL_PLUS',
          title: 'mac调度中心'
        },
        {
          name: 'MAC_ASS',
          value: 'ASSISTANT',
          title: 'mac助手'
        }
      ],
      expChar8:[
        {
          name: 'MouseL',
          value: 'MouseL',
          title: '鼠标左键'
        },
        {
          name: 'MouseR',
          value: 'MouseR',
          title: '鼠标右键'
        },
        {
          name: 'MouseM',
          value: 'MouseM',
          title: '鼠标中键'
        },
        {
          name: 'Mouse4',
          value: 'Mouse4',
          title: '鼠标侧面返回键'
        },
        {
          name: 'Mouse5',
          value: 'Mouse5',
          title: '鼠标侧面前进键'
        },
        {
          name: '',
          value: '',
          title: ''
        },
        {
          name: 'FN',
          value: 'FN',
          title: 'FN'
        },
      ]
    }
  },
  mounted() {
    EventBus.$on('connected', this.getConnectedResult)
  },
  methods: {
    // 获取键盘连接状态回调
    getConnectedResult(val) {
      this.isConnected = val
    },
    tabChange(obj) {
      this.tabList.forEach(e => {
        if (obj.value === e.value) {
          e.status = true
        } else {
          e.status = false
        }
      })
    },
    //按键选择
    keyChange(letter) {
      if (this.isConnected) {
        EventBus.$emit('changeKey', letter)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
  #keysComponent {
    width: 100%;
    height: 100%;
    .top {
      display: flex;
      justify-content: center;
      margin-bottom: 0.2rem;
      border-bottom: 0.03rem solid;
      @include border_color('border-bottom-color');
      height: 0.5rem;
      font-size: 0.15rem;
      //padding: 10px;
      .tabName {
        width: 3rem;
        height: 0.5rem;
        font-weight: 700;
        //line-height: 40px;
        text-align: center;
        //box-shadow: 0 5px 12px rgba(0,0,0,0.5);
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .tabNameActive {
        color: #409EFF;
        border-bottom: 0.03rem solid #409EFF;
      }
    }
    .switchBox {
      .switch {
        height: 0.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        /deep/.el-switch__label:not(.is-active) {
          @include font_color('font_color')
        }
        /deep/.el-switch {
          font-size: 0.14rem !important;
          line-height: 0.2rem !important;
          height: 0.2rem !important;
          .el-switch__label {
            height: 0.2rem;
            font-size: 0.14rem !important;
            span {
              font-size: 0.14rem !important;
            }
          }
          .el-switch__label--left {
            margin-right: 0.1rem;
          }
          .el-switch__label--right {
            margin-left: 0.1rem;
          }
          .el-switch__core {
            width: 0.4rem !important;
            height: 0.2rem;
            border-radius: 0.1rem;
            border-width: 0.01rem;
          }
          .el-switch__core:after {
            top: 0.01rem;
            left: 0.01rem;
            width: 0.16rem;
            height: 0.16rem;
          }
          .el-popover__reference-wrapper {
            font-size: 0.18rem;
          }
        }
        /deep/.el-switch.is-checked .el-switch__core::after {
          margin-left: 0.19rem !important;
        }
      }
    }
    .keys {
      width: 100%;
      height: 100%;
      padding: 0.2rem;
      overflow: auto;
      .keysIn {
        display: flex;
        justify-content: center;
        width: 100%;
        min-width: 15rem;
        height: 100%;
        h4 {
          margin: 0.01rem 0;
          .title {
            border-bottom: 0.02rem solid #3EC1D3;
          }
          .title1 {
            border-bottom: 0.02remsolid #FF9A00;
          }
          .title2 {
            border-bottom: 0.02rem solid #FF165D;
          }
        }
        .btns_box {
          display: flex;
          .btns {
            display: flex;
            width: 9.13rem;
            flex-wrap: wrap;
            font-size: 0.24rem;
            .letter {
              .button_out {
                display: inline-block;
                padding: 0.05rem;
                width: 0.5rem;
                height: 0.5rem;
                box-sizing: border-box;
                .alphabet-button {
                  @include background_color('background_color_key');
                  @include border_color('border_color_key');
                  @include font_color('font_color');
                  border: 0.02rem solid;
                  flex: 0 0 0.56rem;
                  width: 100%;
                  height: 100%;
                  //margin: 5px;
                  padding: 0;
                  font-size: 0.12rem;
                  font-weight: 700;
                  border-radius: 0.05rem;
                  white-space: normal; /* 允许文字换行 */
                  word-wrap: break-word; /* 换行时在单词内部断开 */
                  overflow-wrap: break-word; /* 与word-wrap一起使用，以便在边界处换行 */
                  .iconBox {
                    width: 0.2rem;
                    height: 0.2rem;
                  }
                }
                .alphabet-button:hover {
                  @include border_color('border_color_key_hover');
                  @include font_color('font_color_hover')
                }
              }
              .button_out_other {
                width: 0.6rem !important;
                height: 0.6rem !important;
              }
              .keyBig1 {
                width: 1rem !important;
              }
              .keyBig2 {
                width: 0.75rem !important;
              }
              .keyBig3 {
                width: 0.875rem !important;
              }
              .keyBig4 {
                width: 1.125rem !important;
              }
              .keyBig5 {
                width: 0.625rem !important;
              }
              .keyBig6 {
                width: 3.125rem !important;
              }
              .keyBig7 {
                width: 1.375rem!important;
              }
              .keyBig8 {
                height: 1rem;
              }
              .interval1 {
                margin-right: 0.25rem;
              }
              .interval2 {
                margin-right: 0.5rem;
              }
              .interval3 {
                margin-right: 0.25rem;
              }
              .interval4 {
                margin-right: 0.125rem;
              }
              .interval5 {
                margin-right: 0.5rem;
                margin-left: 0.625rem;
              }
              .interval6 {
                margin-right: 0.5rem;
                margin-bottom: 0.125rem;
              }
              .interval7 {
                margin-right: 1.625rem;
              }
            }
          }
          .btns_other {
            width: 1.5rem !important;
            padding-top: 0.625rem;
            margin-left: 0.125rem !important;
          }
          .btns_pad {
            width: 0.5rem !important;
            padding-top: 0.625rem;
          }
          .btns_feature {
            width: 2.8rem !important;
            height: 50%;
            margin-left: 0.2rem;
          }
        }
      }
    }
  }
</style>
